<template lang="pug">
  #placeholder(@mouseenter="mouseAction('enter')" @mouseleave="mouseAction('leave')")
    .gridContainer
      .gridTile(v-for="(arr, index) in arrs" :style="{ 'width': gridTileWidth, 'height': gridTileGeight, left: arr[0], top: arr[1] }")
        .gridTileImg(:style="{ 'background-size': imageSize, 'background-position':poss[index] }")
      .name YuAn.C
</template>

<script>

export default {
  name: 'ProfileImg',
  data () {
    return {
      rows: 5,
      columns: 5,
      margin: 4,
      arrs: [],
      poss: [],
      gridTileWidth: String,
      gridTileGeight: String,
      imageSize: String
    }
  },
  mounted () {
    this.imageGrid()
    window.addEventListener('resize', this.imageGrid)
  },
  methods: {
    imageGrid () {
      this.arrs = []
      this.poss = []
      const container = document.querySelector('#placeholder .gridContainer')
      let r = this.rows
      let c = this.columns
      let margin = this.margin
      let w = (container.offsetWidth / c) - margin
      let h = (container.offsetHeight / r) - margin
      this.imageSize = `${container.offsetWidth + 115}px ${container.offsetHeight + 10}px`
      this.gridTileWidth = `${w}px`
      this.gridTileGeight = `${h}px`
      for (let i = 0; i < this.rows * this.columns; i++) {
        let arr = []
        arr = [(w + margin) * (i % c) + margin / 2, (h + margin) * Math.floor(i / c) + margin / 2]
        this.arrs.push([`${arr[0]}px`, `${arr[1]}px`])
        const pos = this.fixTilePosition(i, w, h, r, c)
        this.poss.push(`${-arr[0] + pos[0]}px ${-arr[1] + pos[1]}px`)
      }
    },
    fixTilePosition (i, w, h, r, c) {
      let centr, centrCol, centrRow, offsetW, offsetH, left, top
      centr = Math.floor(c * r / 2)
      centrCol = Math.ceil(centr / c)
      centrRow = Math.ceil(centr / r)

      offsetW = 1.2 * w / centrCol
      offsetH = 1.8 * h / centrRow

      left = (Math.round((i % c - centrCol + 1) * offsetW))
      top = (Math.round((Math.floor(i / c) - centrRow + 1) * offsetH))
      return [left, top]
    },
    mouseAction (action = 'leave') {
      this.poss = []
      switch (action) {
        case 'enter':
          for (let i = 0; i < this.rows * this.columns; i++) {
            this.poss.push(`-${this.arrs[i][0]} -${this.arrs[i][1]}`)
          }
          break
        case 'leave':
          this.imageGrid()
          break
      }
    }
  }
}
</script>

<style lang="sass">

#placeholder
  display: inline-block
  position: relative
  width: 100%
  height: 600px
  box-sizing: border-box
.gridContainer
  width: 100%
  height: 100%
  overflow: hidden
  .name
    position: relative
    top: 200px
    left: 10px
    font-size: 9rem
    z-index: 1031
    color: rgba(#000,0.3)
    font-weight: 500
    &::before
      content: '-YuAn.C'
      display: block
      position: absolute
      top: 80px
      left: 20px
      font-size: 3.5rem
      color: white

@media screen and (max-width: 436px)
  #placeholder
    height: 400px

.gridTile
  position: absolute
  overflow: hidden
  .gridTileImg
    position: absolute
    width: 100%
    height: 100%
    background-image: url('../../static/yuan.jpg')
    filter: brightness(0.8)
    background-repeat: no-repeat
    background-origin: content-box
    transition: .5s ease
</style>



// WEBPACK FOOTER //
// src/components/ProfileImg.vue